import React from 'react';
import { Platform, Pressable, StyleSheet, View } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';

// Shared presentation only. Upload handles, previews, retries and edits stay
// with the platform controller. Remove/edit are siblings of the open target.
export default function MediaCardFrame({ styles, media = false, mediaSize, children, onPress, label, onDelete, removeLabel,
  removeDisabled = false, enableFocusRing, onEdit, onMouseEnter, onMouseLeave }) {
  const Body = onPress && !media ? Pressable : View;
  return <View style={[styles.container, media && styles.mediaContainer, media && mediaSize && { width: mediaSize, height: mediaSize }]}
    onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
    {media ? children : <Body style={styles.documentContainer} {...(onPress ? { onPress, accessibilityRole: 'button', accessibilityLabel: label } : {})}>{children}</Body>}
    {!!onDelete && <Pressable style={styles.deleteButton} disabled={removeDisabled} {...(Platform.OS === 'windows' ? { enableFocusRing } : {})}
      accessibilityRole="button" accessibilityLabel={removeLabel} accessibilityState={{ disabled: removeDisabled }}
      onPress={event => { event?.stopPropagation?.(); if (!removeDisabled) onDelete(); }}>
      <Icon name="xmark" size={10} color={StyleSheet.flatten(styles.fileName).color} />
    </Pressable>}
    {!!onEdit && <Pressable style={[styles.deleteButton, onDelete ? { right: 18 } : null]} onPress={onEdit}>
      <Icon name="pen-to-square" size={10} color={StyleSheet.flatten(styles.fileName).color} />
    </Pressable>}
  </View>;
}

export function MediaCardDetails({ styles, icon, color, name, typeLabel, sizeLabel, iconOnly, isSmall, children }) {
  return <>
    <View style={[styles.fileIconContainer, { backgroundColor: color + '20' }]}><Icon name={icon} size={isSmall ? 18 : 24} color={color} /></View>
    {!iconOnly && <View style={styles.fileTextContainer}>
      <Text style={styles.fileName} numberOfLines={1} ellipsizeMode="tail">{name}</Text>
      <View style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
        <Text style={styles.fileType} size={isSmall ? 's' : 'n'}>{typeLabel}</Text>
        <Text style={styles.fileDot} size={isSmall ? 's' : 'n'}>•</Text>
        <Text style={styles.fileType} size={isSmall ? 's' : 'n'}>{sizeLabel}</Text>
        {children}
      </View>
    </View>}
  </>;
}
